<template>
    <div>

        <div class="brdr_box_w_checkbox">
            <div class="r_country">
                <h3>Checkout options</h3>
                <div class="r_country_row mt15">
                    <label class="switch_checkbox_item radio_box_item">
                        <input type="radio" name='checkout_type' @change="$emit('update', 0, 'checkout_type')" :value="0" :checked="appConfig['checkout_type'] === 0">
                        <div class="switch_checkbox"><span></span></div>
                    </label>
                    <p>Single Item Checkout<br> DEFAULT, Allows your customers to buy a single item at a time (+ Order Bump).</p>
                </div>
                <div class="r_country_row mt15">
                    <label class="switch_checkbox_item radio_box_item">
                        <input type="radio" name='checkout_type' @change="$emit('update', 1, 'checkout_type')" :value="1" :checked="appConfig['checkout_type'] === 1">
                        <div class="switch_checkbox"><span></span></div>
                    </label>
                    <p>Multi-Checkout<br> Your Customers will be able to buy this product along others, at once. (+ Order Bump).</p>
                </div>
                <div class="r_country_row mt15">
                    <label class="switch_checkbox_item radio_box_item">
                        <input type="radio" name='checkout_type' @change="$emit('update', 2, 'checkout_type')" :value="2" :checked="appConfig['checkout_type'] === 2">
                        <div class="switch_checkbox"><span></span></div>
                    </label>
                    <p>Multi-Quantity<br> Your Customers will be able to buy multiple items of this product at once. (+ Order Bump).</p>
                </div>
            </div> 
        </div>

        <div class="brdr_box_w_checkbox">
            <div class="right w100">
                <h3>Your Paypal Gateway</h3>
                <p>You can create both sandbox (testing) and live gateways as needed under Account > Gateways.</p>
                <Select2 
                    :value="appConfig['gateway']"
                    @change="$emit('update', $event, 'gateway')" 
                    :options="gateways" 
                    :settings="settings" 
                />
            </div>
        </div>

        <div class="brdr_box_w_checkbox"> 
            <label class="switch_checkbox_item">
                <input type="checkbox" :checked="appConfig['pp_default']" @change="$emit('update', $event.target.checked, 'pp_default')">
                <div class="switch_checkbox"><span></span></div>
            </label>
            <h3>Select PayPal by default</h3>
        </div>

        <div class="brdr_box_w_checkbox">
            <label class="switch_checkbox_item">
                <input type="checkbox" :checked="appConfig['hide_cc']" @change="$emit('update', $event.target.checked, 'hide_cc')">
                <div class="switch_checkbox"><span></span></div>
            </label>
            <h3>Hide credit card option</h3> 
        </div>

    </div>                         
</template>

<script>
export default {
    name: 'PayPalV2',
    props: ['dataBufferObject'],
    data() {
        return {
            gateways: [],
            settings: {dropdownAutoWidth: true, width: '100%'},
            appConfig: {}
        }
    },
    created(){
        if(this.dataBufferObject) {
            this.appConfig = this.dataBufferObject;
        } else {
            this.appConfig = JSON.parse("{\"gateway\":0,\"checkout_type\":0,\"pp_default\":false,\"hide_cc\":false}")
        }
    }
}
</script>